import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getHotelsInfo } from 'httpClient/requests/searchResults';
import { templatesDestinationsOperations } from 'state/templates/destinations';
import CountryTemplateComponent from './CountryTemplateComponent';
import * as fetchingStatus from 'constants/status/fetchingStatus';

class CountryTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hotels: [],
    };
  }
  componentDidMount() {
    const { destinations } = this.props;
    const { hotels } = this.state;

    if (destinations.length === 0) {
      this.props.fetchDestinations();
      return;
    }
    if (hotels.length === 0) {
      this.handleHotelsInfoForCountry();
    }
  }

  componentDidUpdate() {
    const { destinations } = this.props;
    const { hotels } = this.state;

    if (destinations.length > 0 && hotels.length === 0) {
      this.handleHotelsInfoForCountry();
    }
  }

  handleHotelsInfoForCountry = () => {
    const { content, destinations } = this.props;
    const selectedCountry = destinations.find((country) => country.code === content.country_code);

    if (!selectedCountry) return;

    const destinationsCode = selectedCountry.destinations.map((destination) => destination.code);

    getHotelsInfo({ destinations: destinationsCode })
      .then((response) => {
        this.setState({
          hotels: response.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    const { content, destinations, redirectToCountriesTemplatePage, destinationsFetching } = this.props;
    const { hotels } = this.state;

    const country = destinations.filter(({ code }) => code === content.country_code).pop();
    const destinationsMap = country && country.destinations.map(({ code, name }) => ({ code, name }));
    const recommendedHotelsLabel = country && country.name;
    const showSpinner = destinations.length === 0 || hotels.length === 0;

    if (
      !country &&
      (destinationsFetching === fetchingStatus.SUCCEEDED || destinationsFetching === fetchingStatus.FAILED)
    ) {
      if (process.browser) {
        redirectToCountriesTemplatePage();
      }
      return null;
    }

    return (
      <CountryTemplateComponent
        content={content}
        country={country}
        destinationsMap={destinationsMap}
        recommendedHotelsLabel={recommendedHotelsLabel}
        hotels={hotels}
        buttonLinksTo={'all-destinations'}
        showSpinner={showSpinner}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    destinations: state.templates.destinations.destinations,
    destinationsFetching: state.templates.destinations.fetching,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchDestinations: function () {
      dispatch(templatesDestinationsOperations.fetchDestinations());
    },
    redirectToCountriesTemplatePage: function () {
      dispatch(templatesDestinationsOperations.redirectToCountriesTemplatePage());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryTemplate);
